/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftOwnership } from './NftOwnership';
import {
    NftOwnershipFromJSON,
    NftOwnershipFromJSONTyped,
    NftOwnershipToJSON,
    NftOwnershipToJSONTyped,
} from './NftOwnership';

/**
 * Represents an array of arrays where each parent array contains all the nftOwnerships for a particular user.
 * @export
 * @interface NftOwnershipMatrix
 */
export interface NftOwnershipMatrix extends Array<NftOwnership> {
}

/**
 * Check if a given object implements the NftOwnershipMatrix interface.
 */
export function instanceOfNftOwnershipMatrix(value: object): value is NftOwnershipMatrix {
    return true;
}

export function NftOwnershipMatrixFromJSON(json: any): NftOwnershipMatrix {
    return NftOwnershipMatrixFromJSONTyped(json, false);
}

export function NftOwnershipMatrixFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftOwnershipMatrix {
    return json;
}

export function NftOwnershipMatrixToJSON(json: any): NftOwnershipMatrix {
    return NftOwnershipMatrixToJSONTyped(json, false);
}

export function NftOwnershipMatrixToJSONTyped(value?: NftOwnershipMatrix | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

